require('./Css/carousel.scss');
require('./Css/tabs.scss');
require('./Css/tab-stock.scss');
require('./Css/tab-map.scss');
require('./Css/callback.scss');
require('./Js/tabs.js');
require('./Js/tabSelection.js');
require('./Js/jquery.cycle2.js');
require('./Js/map.js');
require('../EmailDetails/Assets/Css/email-details-form.scss');
require('../EmailDetails/Assets/Js/email-details-form.js');